import { render } from "./PageWebContent.vue?vue&type=template&id=98d66a10&scoped=true"
const script = {}

import "./PageWebContent.vue?vue&type=style&index=0&id=98d66a10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d66a10"]])

export default __exports__